import React from "react";

function Page4() {
  return (
    <div className="page-container">
      <div
        className="page"
        style={{
          width: "93%",
          height: "1209px",
          margin: "20px auto 20px auto",
          boxShadow: "0 0 2rem 0 rgba(136, 152, 170, 0.5)",
        }}
      >
        <div
          id="pg4Overlay"
          style={{
            WebkitUserSelect: "none",
            backgroundColor: "rgba(0,0,0,0)",
            height: "100%",
            position: "absolute",
            width: "100%",
            zIndex: "1",
          }}
        />
        <div className="text-container">
          <span
            className="t s0"
            style={{
              bottom: "1138px",
              left: "55px",
              letterSpacing: "-0.15px",
            }}
          >
            Form W-9 (Rev. 3-2024){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1137px",
              left: "844px",
              letterSpacing: "-0.14px",
            }}
          >
            Page{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "1135px",
              left: "872px",
            }}
          >
            4{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1106px",
              left: "63px",
              letterSpacing: "0.1px",
            }}
          >
            2—The United States or any of its agencies or instrumentalities.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1088px",
              left: "63px",
              letterSpacing: "0.1px",
            }}
          >
            3—A state, the District of Columbia, a U.S. commonwealth or
            territory,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1074px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            or any of their political subdivisions or instrumentalities.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1056px",
              left: "63px",
              letterSpacing: "0.1px",
            }}
          >
            4—A foreign government or any of its political subdivisions,
            agencies,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1042px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            or instrumentalities.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1024px",
              left: "63px",
              letterSpacing: "0.11px",
            }}
          >
            5—A corporation.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1005px",
              left: "63px",
              letterSpacing: "0.1px",
            }}
          >
            6—A dealer in securities or commodities required to register in the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "992px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            United States, the District of Columbia, or a U.S. commonwealth or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "978px",
              left: "55px",
              letterSpacing: "0.08px",
            }}
          >
            territory.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "959px",
              left: "63px",
              letterSpacing: "0.11px",
            }}
          >
            7—A futures commission merchant registered with the Commodity{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "946px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Futures Trading Commission.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "927px",
              left: "63px",
              letterSpacing: "0.1px",
            }}
          >
            8—A real estate investment trust.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "909px",
              left: "63px",
              letterSpacing: "0.1px",
            }}
          >
            9—An entity registered at all times during the tax year under the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "895px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Investment Company Act of 1940.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "877px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            10—A common trust fund operated by a bank under section 584(a).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "859px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            11—A financial institution as defined under section 581.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "840px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            12—A middleman known in the investment community as a nominee or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "827px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            custodian.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "808px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            13—A trust exempt from tax under section 664 or described in section{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "794px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            4947.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "776px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            The following chart shows types of payments that may be exempt{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "762px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            from backup withholding. The chart applies to the exempt payees
            listed{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "749px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            above, 1 through 13.{" "}
          </span>
          <span
            className="t s3 w-100"
            style={{
              bottom: "727px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-36px",
                left: "-10px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            IF the payment is for . . .{" "}
            <hr
              className="t s3"
              style={{
                top: "-1px",
                left: "-10px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            <hr
              className="t s3"
              style={{
                top: "261px",
                left: "196px",
                height: "297px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
          </span>
          <span
            className="t s3"
            style={{
              bottom: "727px",
              left: "259px",
              letterSpacing: "0.11px",
            }}
          >
            THEN the payment is exempt{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "714px",
              left: "259px",
              letterSpacing: "0.07px",
            }}
          >
            for . . .{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "692px",
              left: "58px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "692px",
              left: "71px",
              letterSpacing: "0.1px",
            }}
          >
            Interest and dividend payments{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "692px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            All exempt payees except{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "678px",
              left: "259px",
              letterSpacing: "0.09px",
            }}
          >
            for 7.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "660px",
              left: "58px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "660px",
              left: "71px",
              letterSpacing: "0.1px",
            }}
          >
            Broker transactions{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "660px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            Exempt payees 1 through 4 and 6{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "646px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            through 11 and all C corporations.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "633px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            S corporations must not enter an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "619px",
              left: "259px",
              letterSpacing: "0.11px",
            }}
          >
            exempt payee code because they{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "605px",
              left: "259px",
              letterSpacing: "0.09px",
            }}
          >
            are exempt only for sales of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "591px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            noncovered securities acquired{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "578px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            prior to 2012.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "559px",
              left: "58px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "559px",
              left: "71px",
              letterSpacing: "0.1px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-33px",
                left: "-25px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Barter exchange transactions{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "545px",
              left: "58px",
              letterSpacing: "0.11px",
            }}
          >
            and patronage dividends{" "}
            <hr
              className="t s3"
              style={{
                top: "-14px",
                left: "-12px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s6"
            style={{
              bottom: "559px",
              left: "259px",
              letterSpacing: "0.11px",
            }}
          >
            Exempt payees 1 through 4.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "527px",
              left: "58px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "527px",
              left: "71px",
              letterSpacing: "0.1px",
            }}
          >
            Payments over $600 required to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "513px",
              left: "58px",
              letterSpacing: "0.1px",
            }}
          >
            be reported and direct sales over{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "497px",
              left: "58px",
              letterSpacing: "0.11px",
            }}
          >
            $5,000{" "}
            <hr
              className="t s3"
              style={{
                top: "-14px",
                left: "-12px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t se"
            style={{
              bottom: "505px",
              left: "95px",
            }}
          >
            1{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "527px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            Generally, exempt payees{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "511px",
              left: "259px",
              letterSpacing: "0.1px",
            }}
          >
            1 through 5.{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "519px",
              left: "325px",
            }}
          >
            2{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "478px",
              left: "58px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "478px",
              left: "71px",
              letterSpacing: "0.1px",
            }}
          >
            Payments made in settlement of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "465px",
              left: "58px",
              letterSpacing: "0.1px",
            }}
          >
            payment card or third-party{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "451px",
              left: "58px",
              letterSpacing: "0.1px",
            }}
          >
            network transactions{" "}
            <hr
              className="t s3"
              style={{
                top: "-16px",
                left: "-10px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s6"
            style={{
              bottom: "478px",
              left: "259px",
              letterSpacing: "0.11px",
            }}
          >
            Exempt payees 1 through 4.{" "}
          </span>
          <span
            className="t sf"
            style={{
              bottom: "436px",
              left: "55px",
            }}
          >
            1{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "430px",
              left: "62px",
              letterSpacing: "0.1px",
            }}
          >
            See Form 1099-MISC, Miscellaneous Information, and its instructions.{" "}
          </span>
          <span
            className="t sf"
            style={{
              bottom: "418px",
              left: "55px",
            }}
          >
            2{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "412px",
              left: "62px",
              letterSpacing: "0.1px",
            }}
          >
            However, the following payments made to a corporation and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "399px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            reportable on Form 1099-MISC are not exempt from backup{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "385px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            withholding: medical and health care payments, attorneys’ fees,
            gross{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "371px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            proceeds paid to an attorney reportable under section 6045(f), and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "358px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            payments for services paid by a federal executive agency.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "339px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Exemption from FATCA reporting code.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "339px",
              left: "288px",
              letterSpacing: "0.1px",
            }}
          >
            The following codes identify{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "325px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            payees that are exempt from reporting under FATCA. These codes{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "312px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            apply to persons submitting this form for accounts maintained
            outside{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "298px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            of the United States by certain foreign financial institutions.
            Therefore, if{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "284px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            you are only submitting this form for an account you hold in the
            United{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "270px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            States, you may leave this field blank. Consult with the person{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "257px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            requesting this form if you are uncertain if the financial
            institution is{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "243px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            subject to these requirements. A requester may indicate that a code
            is{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "229px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            not required by providing you with a Form W-9 with “Not Applicable”
            (or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "215px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            any similar indication) entered on the line for a FATCA exemption
            code.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "197px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            A—An organization exempt from tax under section 501(a) or any{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "183px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            individual retirement plan as defined in section 7701(a)(37).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "165px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            B—The United States or any of its agencies or instrumentalities.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "147px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            C—A state, the District of Columbia, a U.S. commonwealth or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "133px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            territory, or any of their political subdivisions or
            instrumentalities.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "115px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            D—A corporation the stock of which is regularly traded on one or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "101px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            more established securities markets, as described in Regulations{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "87px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            section 1.1472-1(c)(1)(i).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "69px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            E—A corporation that is a member of the same expanded affiliated{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "55px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            group as a corporation described in Regulations section
            1.1472-1(c)(1)(i).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1106px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            F—A dealer in securities, commodities, or derivative financial{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1092px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            instruments (including notional principal contracts, futures,
            forwards,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1079px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            and options) that is registered as such under the laws of the United{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1065px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            States or any state.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1047px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            G—A real estate investment trust.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1028px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            H—A regulated investment company as defined in section 851 or an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1014px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            entity registered at all times during the tax year under the
            Investment{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1001px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            Company Act of 1940.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "982px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            I—A common trust fund as defined in section 584(a).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "964px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            J—A bank as defined in section 581.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "946px",
              left: "496px",
              letterSpacing: "0.12px",
            }}
          >
            K—A broker.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "927px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            L—A trust exempt from tax under section 664 or described in section{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "914px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            4947(a)(1).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "895px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            M—A tax-exempt trust under a section 403(b) plan or section 457(g){" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "882px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            plan.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "863px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "863px",
              left: "519px",
              letterSpacing: "0.1px",
            }}
          >
            You may wish to consult with the financial institution requesting{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "849px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            this form to determine whether the FATCA code and/or exempt payee{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "836px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            code should be completed.{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "811px",
              left: "484px",
              letterSpacing: "0.13px",
            }}
          >
            Line 5{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "793px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Enter your address (number, street, and apartment or suite number).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "779px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            This is where the requester of this Form W-9 will mail your
            information{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "765px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            returns. If this address differs from the one the requester already
            has on{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "752px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            file, enter “NEW” at the top. If a new address is provided, there is
            still a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "738px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            chance the old address will be used until the payor changes your{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "724px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            address in their records.{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "699px",
              left: "484px",
              letterSpacing: "0.13px",
            }}
          >
            Line 6{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "681px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Enter your city, state, and ZIP code.{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "651px",
              left: "484px",
              letterSpacing: "0.16px",
            }}
          >
            Part I. Taxpayer Identification Number (TIN){" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "634px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Enter your TIN in the appropriate box.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "634px",
              left: "707px",
              letterSpacing: "0.09px",
            }}
          >
            If you are a resident{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "634px",
              left: "818px",
              letterSpacing: "0.09px",
            }}
          >
            alien and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "620px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            you do not have, and are not eligible to get, an SSN,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "620px",
              left: "773px",
              letterSpacing: "0.09px",
            }}
          >
            your TIN is your{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "607px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            IRS ITIN. Enter it in the entry space for the Social security
            number. If you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "593px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            do not{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "593px",
              left: "523px",
              letterSpacing: "0.1px",
            }}
          >
            have an ITIN, see{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "593px",
              left: "621px",
              letterSpacing: "0.1px",
            }}
          >
            How to get a TIN{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "593px",
              left: "716px",
              letterSpacing: "0.11px",
            }}
          >
            below.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "574px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            If you are a sole proprietor and you have an EIN, you may enter
            either{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "561px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            your SSN or EIN.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "542px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            If you are a single-member LLC that is disregarded as an entity{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "529px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            separate from its owner, enter the owner’s SSN (or EIN, if the owner
            has{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "515px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            one). If the LLC is classified as a corporation or partnership,
            enter the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "501px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            entity’s EIN.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "483px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "483px",
              left: "519px",
              letterSpacing: "0.1px",
            }}
          >
            See{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "483px",
              left: "543px",
              letterSpacing: "0.11px",
            }}
          >
            What Name and Number To Give the Requester
          </span>
          <span
            className="t s6"
            style={{
              bottom: "483px",
              left: "803px",
              letterSpacing: "0.07px",
            }}
          >
            , later, for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "469px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            further clarification of name{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "469px",
              left: "637px",
              letterSpacing: "0.11px",
            }}
          >
            and TIN combinations.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "451px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            How to get a TIN.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "451px",
              left: "589px",
              letterSpacing: "0.1px",
            }}
          >
            If you do not have a TIN, apply for one{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "451px",
              left: "801px",
              letterSpacing: "0.1px",
            }}
          >
            immediately.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "437px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            To apply for an SSN, get Form SS-5, Application{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "437px",
              left: "753px",
              letterSpacing: "0.09px",
            }}
          >
            for a Social Security{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "423px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            Card, from your local SSA office or get this form online at{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "409px",
              left: "484px",
              letterSpacing: "0.13px",
            }}
          >
            www.SSA.gov
          </span>
          <span
            className="t s6"
            style={{
              bottom: "409px",
              left: "563px",
              letterSpacing: "0.1px",
            }}
          >
            . You{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "409px",
              left: "594px",
              letterSpacing: "0.1px",
            }}
          >
            may also get this form by calling 800-772-1213. Use{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "396px",
              left: "484px",
              letterSpacing: "0.13px",
            }}
          >
            Form{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "396px",
              left: "516px",
              letterSpacing: "0.1px",
            }}
          >
            W-7, Application for IRS Individual Taxpayer Identification{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "382px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Number, to apply for an ITIN, or Form SS-4, Application for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "382px",
              left: "810px",
              letterSpacing: "0.1px",
            }}
          >
            Employer{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "368px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Identification Number, to apply for an EIN. You can{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "368px",
              left: "765px",
              letterSpacing: "0.09px",
            }}
          >
            apply for an EIN{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "354px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            online by accessing the IRS website at{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "354px",
              left: "698px",
              letterSpacing: "0.11px",
            }}
          >
            www.irs.gov/EIN
          </span>
          <span
            className="t s6"
            style={{
              bottom: "354px",
              left: "789px",
              letterSpacing: "0.08px",
            }}
          >
            . Go to{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "341px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            www.irs.gov/Forms{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "341px",
              left: "593px",
              letterSpacing: "0.1px",
            }}
          >
            to view, download, or print Form W-7 and/or Form{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "327px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            SS-4. Or, you can go to{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "327px",
              left: "617px",
              letterSpacing: "0.11px",
            }}
          >
            www.irs.gov/OrderForms{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "327px",
              left: "757px",
              letterSpacing: "0.1px",
            }}
          >
            to place an order and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "313px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            have Form W-7 and/or Form SS-4 mailed to you within 15 business{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "299px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            days.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "281px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            If you are asked to complete Form W-9 but do not have a TIN, apply{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "267px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            for a TIN and enter “Applied For” in the space for the TIN, sign and
            date{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "254px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            the form, and give it to the requester. For interest and dividend{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "240px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            payments, and certain payments made with respect to readily tradable{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "226px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            instruments, you will generally have 60 days to get a TIN and give
            it to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "212px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            the requester before you are subject to backup withholding on{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "199px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            payments. The 60-day rule does not apply to other types of payments.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "185px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            You will be subject to backup withholding on all such payments until{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "171px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            you provide your TIN to the requester.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "153px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "153px",
              left: "519px",
              letterSpacing: "0.1px",
            }}
          >
            Entering “Applied For” means that you have already{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "153px",
              left: "805px",
              letterSpacing: "0.09px",
            }}
          >
            applied for a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "139px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            TIN or that you intend to apply for one soon. See also{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "139px",
              left: "779px",
              letterSpacing: "0.09px",
            }}
          >
            Establishing U.S.{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "125px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            status for purposes of chapter 3 and chapter 4 withholding
          </span>
          <span
            className="t s6"
            style={{
              bottom: "125px",
              left: "803px",
              letterSpacing: "0.07px",
            }}
          >
            , earlier, for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "112px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            when you may instead be subject to withholding under chapter 3 or 4
            of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "98px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            the Code.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "79px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Caution:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "79px",
              left: "536px",
              letterSpacing: "0.1px",
            }}
          >
            A disregarded U.S. entity that has a foreign owner{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "79px",
              left: "812px",
              letterSpacing: "0.1px",
            }}
          >
            must use{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "66px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            the appropriate Form W-8.{" "}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Page4;
